import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IPagination, IPaginationParams } from "@/types/pagination";
import type { IExamReport } from "../exam_papers/getExamReport";

export interface IExamReportsParams extends IPaginationParams {
  user_id?: string;
  exam_set_id?: string;
  exam_type?: string;
  search?: string;
  sort?:
    | "user_name"
    | "exam_set_title"
    | "exam_type"
    | "total_score"
    | "created_at"
    | "updated_at"
    | "exam_started_at";
  sort_order?: "asc" | "desc";
}

/**
 * 시험 리포트 목록 조회 API 함수 (관리자용)
 * @param params 조회 파라미터
 * @returns API 응답 객체
 */
export const apiGetExamReports = async (params: IExamReportsParams = {}) => {
  return apiGet<IPagination<IExamReport>>("/exam_reports", params);
};

/**
 * 시험 리포트 목록 조회 React Query 훅 (관리자용)
 * @param params 조회 파라미터
 * @param options 쿼리 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetExamReports = (
  params: IExamReportsParams = {},
  options = {}
) => {
  return useQuery({
    queryKey: ["examReports", params],
    queryFn: () => apiGetExamReports(params),
    select: (response) => response.data,
    ...options,
  });
};

export default useQueryGetExamReports;
